import { render } from "./categoryDesign.vue?vue&type=template&id=b6355c04"
import script from "./categoryDesign.vue?vue&type=script&lang=js"
export * from "./categoryDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__